export const USER_ORDER_FEED_CONNECT = 'USER_ORDER_FEED_CONNECT' as const;

export const USER_ORDER_FEED_DISCONNECT = 'USER_ORDER_FEED_DISCONNECT' as const;

export const USER_ORDER_FEED_MESSAGE = 'USER_ORDER_FEED_MESSAGE' as const;

export const USER_ORDER_FEED_ERROR = 'USER_ORDER_FEED_ERROR' as const;

export const USER_ORDER_FEED_CLOSE = 'USER_ORDER_FEED_CLOSE' as const;

export const USER_ORDER_FEED_OPEN = 'USER_ORDER_FEED_OPEN' as const;

export const USER_ORDER_FEED_CONNECTING = 'USER_ORDER_FEED_CONNECTING' as const;
